import { FC, useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { useRouteMatch } from 'react-router-dom';
import DomainUrlRedirect from './domainUrlRedirect';
import { httpGet } from '../../modules/api/axios_api';
import Constants from '../../constants/constants';
import LoaderPage from '../pages/LoaderPage';
import { theme } from '../theme';

import GlobalStyles from '../components/GlobalStyles';

const apiUrl = import.meta.env.VITE_API_SERVER;

const getAppName = (path: string) => {
  const regex = /\/sso\/(?<application>.*)/;
  const result = regex.exec(path);
  return result?.groups?.application;
};

const redirectWrapper = (ssoAuthToken: string, ssoAppName: string, pathname: string | null = null) => {
  const redirectURL = Constants.SSO_REDIRECT_URLS[ssoAppName];
  if (pathname === null) {
    return <DomainUrlRedirect url={redirectURL} pathname={'auth/jwt'} searchParams={{ jwt: ssoAuthToken }} />;
  } else {
    const _pathname = pathname.replace(':token', ssoAuthToken);
    return <DomainUrlRedirect url={redirectURL} pathname={_pathname} />;
  }
};

const SsoRedirect: FC<{ pathname: string }> = ({ pathname }) => {
  const match = useRouteMatch();

  const [ssoAuthToken, setSsoAuthToken] = useState(null);
  const ssoAppName = getAppName(match.path);

  useEffect(() => {
    httpGet(`${apiUrl}/sso/${ssoAppName}`, {}).then((response) => setSsoAuthToken(response?.data.token));
  }, [ssoAppName]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      {!ssoAuthToken && <LoaderPage />}
      {ssoAuthToken && ssoAppName && redirectWrapper(ssoAuthToken, ssoAppName, pathname)}
    </ThemeProvider>
  );
};

export default SsoRedirect;
